import React, { } from "react";
import { Form, Col } from 'react-bootstrap';
import { useDispatch } from 'redux-react-hook';

export default function SettingLimit(props) {
    const questionIndex = props.index;
    const data = props.data || { ty: 0, min: 1, max: 3 };
    if (null == data.ty) {
        if (null != data.min && null != data.max) data.ty = 1;
        else data.ty = 0;
    }
    // console.log(props, data)
    const MIN_MIN = 1, MAX_MIN = 1;
    const min = null != data.min && false == isNaN(data.min) ? data.min : -1;
    const max = null != data.max && false == isNaN(data.max) ? data.max : -1;
    const dispatch = useDispatch();
    // console.log(props);

    function onChangeMin(e) {
        try {
            let tmp = parseInt(e.target.value);
            if (tmp < MIN_MIN) tmp = MIN_MIN;
            // console.log(tmp, e.target.value, MIN_MIN);
            dispatch({
                type: "QUESTION_SET_LIMIT",
                index: questionIndex,
                data: {
                    ...data,
                    min: tmp
                }
            });
        } catch (e) {

        }
    }
    function onChangeMax(e) {
        try {
            let tmp = parseInt(e.target.value);
            if (tmp < MAX_MIN) tmp = MAX_MIN;
            // console.log(tmp, e.target.value, MAX_MIN);
            dispatch({
                type: "QUESTION_SET_LIMIT",
                index: questionIndex,
                data: {
                    ...data,
                    max: tmp
                }
            });
        } catch (e) {

        }
    }

    function onSelectType(e) {
        try {
            let tmp = parseInt(e.currentTarget.value);
            if (false == isNaN(tmp)) {
                console.log(tmp);
                dispatch({
                    type: "QUESTION_SET_LIMIT",
                    index: questionIndex,
                    data: {
                        ...data,
                        ty: tmp
                    }
                });
            }
        } catch (e) {

        }
    }

    function render() {
        let limitOpt = (
            <>
                <Form.Row>
                    <Form.Label column xs="3">min:</Form.Label>
                    <Col className="text-left">
                        <Form.Control onChange={onChangeMin} type="number" value={min} />
                    </Col>
                </Form.Row>
                <Form.Row>
                    <Form.Label column xs="3">max:</Form.Label>
                    <Col className="text-left">
                        <Form.Control onChange={onChangeMax} type="number" value={max} />
                    </Col>
                </Form.Row>
            </>
        );
        // console.log(min, max);
        return (
            <Form.Group>
                <Form>
                    <Form.Row>
                        <Col className="text-left">
                            <Form.Check onChange={onSelectType} type="radio" checked={data.ty == 0 || data.ty == "0"} name={questionIndex + "-limit"} value="0" label="不限制" />
                        </Col>
                        <Col className="text-left">
                            <Form.Check onChange={onSelectType} type="radio" checked={data.ty == 1 || data.ty == "1"} name={questionIndex + "-limit"} value="1" label="限制" />
                        </Col>
                    </Form.Row>
                    {data.ty != 0 ? limitOpt : null}
                </Form>
            </Form.Group>
        );
    }

    return render();
}
